"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiMooDrop = function IconUiMooDrop(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M24.864 3.575a1.04 1.04 0 0 0-1.728 0c-9.9 17.02-11.264 19.415-11.4 19.691a13.335 13.335 0 0 0-1.684 6.655 13.445 13.445 0 0 0 4.074 9.823 15.557 15.557 0 0 0 1.155 1.045A13.249 13.249 0 0 0 24 43.869c.51 0 1-.018 1.5-.057a13.434 13.434 0 0 0 8.373-4.068 13.445 13.445 0 0 0 4.074-9.823 13.289 13.289 0 0 0-1.659-6.61c-.16-.321-1.519-2.711-11.424-19.736zm7.591 34.76a11.322 11.322 0 0 1-7.133 3.485q-.636.05-1.322.049a11.159 11.159 0 0 1-7.446-2.623c-.352-.288-.694-.6-1.014-.916a11.365 11.365 0 0 1-3.488-8.409 11.416 11.416 0 0 1 1.448-5.715c.156-.311 2.129-3.753 10.5-18.14C32.371 20.453 34.345 23.9 34.524 24.251a11.359 11.359 0 0 1 1.424 5.67 11.37 11.37 0 0 1-3.493 8.414z"
  }));
};

IconUiMooDrop.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiMooDrop;
exports.default = _default;